"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isSubscriptionRef(subscriberRef) {
    return subscriberRef && subscriberRef["subscription"];
}
exports.isSubscriptionRef = isSubscriptionRef;
